import React, { useEffect, useState } from 'react';
import { GlobalFilterModal } from './components/GlobalFilterModal';
import { useAppLanguage } from '@/core/hooks/useAppLanguage';
import { useExcludedChannelKeys } from '@/features/global-filter/hooks/useExcludedChannelKeys';
import { prefetchSelectorItems } from '@/core/hooks/useSelectorItems';

const OPEN_FILTER_EVENT = 'mfe-filter-bar-open-filter';

interface GlobalFilterAppProps {
  isExportMode?: boolean;
}

export const GlobalFilterApp: React.FC<GlobalFilterAppProps> = ({
  isExportMode = false,
}) => {
  useAppLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const excludedChannelKeys = useExcludedChannelKeys();

  useEffect(() => {
    prefetchSelectorItems();
  }, []);

  useEffect(() => {
    const handleOpen = () => setIsOpen(true);
    document.addEventListener(OPEN_FILTER_EVENT, handleOpen);
    return () => document.removeEventListener(OPEN_FILTER_EVENT, handleOpen);
  }, []);

  if (!isOpen) return null;

  return (
    <GlobalFilterModal
      isExportMode={isExportMode}
      excludedChannelKeys={excludedChannelKeys}
      onClose={() => {
        setIsOpen(false);
      }}
    />
  );
};
